export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'LOCATION_TIME_INTERVAL_SET':
      return payload
    case 'LOGOUT':
      return null
    default:
      return state
  }
}
